<template>
  <div class="c-cabinet-shipment-info" v-loading.fullscreen.lock="isLoading" :element-loading-text="loadingText">
    <el-form ref="formRef" :model="dataModel">
      <!-- 商品信息 -->
      <div class="c-cabinet-info-card">
        <div class="c-info-card--header" style="justify-content: space-between">
          <div style="min-width: 570px">
            <div style="display: flex; align-items: center">
              <span class="icon"></span>
              <span class="title" style="margin-right: 10px">商品信息</span>

              <!-- 选择商品 -->
              <c-action v-bind="productAttrs" />
              <!-- 清空商品 -->
              <c-action v-bind="clearAttrs" style="margin-left: 10px" />
            </div>
          </div>
        </div>
        <el-table ref="tableRef" :data="ProductInfoData" border style="width: 100%">
          <el-table-column align="center" property="productCode" label="商品编号" min-width="100" />
          <el-table-column align="center" property="productName" label="商品名称" min-width="100" />
          <el-table-column align="center" property="supplierName" label="供应商" min-width="100" />
          <el-table-column align="center" property="productSpec" label="商品规格" min-width="100" />
          <el-table-column align="center" property="costPrice" label="成本价（元）" min-width="160">
            <template #default="{ row }">
              <el-input-number
                v-model="row.costPrice"
                :min="0.01"
                :max="99999.99"
                :precision="2"
                @change="handleChangePrice(row)"
              />
            </template>
          </el-table-column>
          <el-table-column align="center" property="salePrice" label="销售价（元）" min-width="160">
            <template #default="{ row }">
              <el-input-number
                v-model="row.salePrice"
                :min="0.01"
                :max="99999.99"
                :precision="2"
                @change="handleChangePrice(row)"
              />
            </template>
          </el-table-column>
          <el-table-column align="center" property="linePrice" label="划线价（元）" min-width="160">
            <template #default="{ row }">
              <el-input-number
                v-model="row.linePrice"
                :min="0.01"
                :max="99999.99"
                :precision="2"
                @change="handleChangePrice(row)"
              />
            </template>
          </el-table-column>
          <el-table-column align="center" property="totalShipCount" label="总发货数量" min-width="160">
            <template #default="{ row }">
              <el-input-number
                :disabled="type === 'editReceive'"
                v-model="row.totalShipCount"
                :min="1"
                :max="100"
                :precision="0"
                @change="handleChangeTotalShipCount(row)"
              />
            </template>
          </el-table-column>

          <el-table-column align="center" property="" fixed="right" label="操作" min-width="80">
            <template #default="{ $index }">
              <el-button type="text" @click="handleRemove($index)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 基础信息 -->
      <div class="c-cabinet-info-card">
        <div class="c-info-card--header">
          <span class="icon"></span>
          <span class="title">基础信息</span>
        </div>
        <c-form-items :items="AddEditBasicInfoFormItems" :model="dataModel" :showOperation="false" />
      </div>

      <!-- 操作按钮 -->
      <div class="footer-wrap">
        <el-form-item>
          <el-button v-preventReclick @click="onCancel">取消</el-button>
          <el-button type="primary" v-preventReclick @click="handleDialogSubmit">确定</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, computed, ref, useCurrentAppInstance, useApiRequest, PageContext } from '@zto/zpage'
import { AddEditBasicInfoFormItems } from './config'
import { RbacRoleScopeType } from '@/config/enums'
import Decimal from 'decimal.js'

const app = useCurrentAppInstance()
const router = app.router
const route = app.router.currentRoute.value

const type: any = route.query?.type || undefined
const shipmentOrderCode: any = route.query?.shipmentOrderCode || undefined

const { userStore } = app.stores
const apiRequest = useApiRequest()
const { MessageBox, Message } = app.useMessage()

const formRef = ref<any>()
const dataModel = ref<any>({})

// onBeforeMount(async () => {
//   await initData()
// })

// 弹窗提交
async function handleDialogSubmit() {
  try {
    const form = formRef.value
    if (form.validate) {
      const valid = await form.validate()
      if (!valid) return
      switch (type) {
        case 'add':
          submitAddOrEditForm(type)
          break

        default:
          break
      }
    }
  } catch (error) {
    console.log('error===', error)
  }
}

// 初始化数据
async function initData() {
  dataModel.value = {}
  ProductInfoData.value = []
}

// 获取商品信息
async function getItems() {
  // 商品列表
  const items = ProductInfoData.value?.map((item: any) => {
    return {
      productCode: item.productCode,
      totalShipCount: item.totalShipCount,
      costPrice: item.costPrice,
      salePrice: item.salePrice,
      linePrice: item.linePrice
    }
  })

  return items
}

// 新增时loading
const isLoading = ref(false)
const loadingText = '加载中...'
// 新增
async function submitAddOrEditForm(type: string) {
  if (!ProductInfoData.value?.length) {
    Message.warning('请至少选择一个商品！')
    return false
  }

  isLoading.value = true

  // 获取商品信息
  const items = await getItems()

  let action = ''
  switch (type) {
    case 'add':
      action = '/cabinet/admin/oms/AdminOmsShipmentCommandController/create'
      break
    default:
      break
  }
  try {
    const params = {
      ...dataModel.value,
      ...dataModel.value?.receivePCD?.[0],
      ...items?.[0]
    }

    delete params.receivePCD

    await apiRequest({
      action,
      params
    })
    let message = ''
    switch (type) {
      case 'add':
        message = '新增发货单成功！'
        break
      default:
        break
    }

    Message.success(message)
    isLoading.value = false
    router.close()
  } catch (error) {
    console.log('error===', error)
    isLoading.value = false
  }
}

// 商品信息
const ProductInfoData = ref<any>([])

// 取消
function onCancel() {
  MessageBox.confirm('是否确定取消？', {
    title: '确认提示',
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  })
    .then(() => {
      formRef.value.resetFields()
      router.close()
    })
    .catch(() => {})
}

// 移除
const handleRemove = (index: number) => {
  ProductInfoData.value.splice(index, 1)
  app.setPageData('checkedArr', [])
}

// 价格 change时，计算
const handleChangePrice = (row: any) => {
  console.log('row===', row)
}

// 购买数量change时，计算
const handleChangeTotalShipCount = (row: any) => {
  console.log('row===', row)
}

const productAttrs = {
  label: '选择商品',
  dialog: {
    title: '选择商品',
    width: '70%',
    bodyHeight: '60vh',
    top: '10vh',
    // size: 'large',
    onShow: async ({ app, data }: PageContext) => {
      const basic = app.stores.userStore?.data?.basic || {}
      console.info('🚀 ~ file:index method:dynamicAttrs line:42 ----- basic', basic)
      return {
        payload: {
          ...data,
          supplier: basic.belongType === RbacRoleScopeType.SUPPLIER ? basic.supplierOrgName : ''
        }
      }
    },
    onSubmit: async (data: any, options: any, _: any, dialogExposed: any) => {
      const checkedArr = app.getPageData('checkedArr') || []
      checkedArr?.map((item: any) => {
        item.totalShipCount = 1
        return item
      })
      const _ProductInfoData = [...ProductInfoData.value, ...checkedArr]
      if (_ProductInfoData?.length > 1) {
        Message.warning(`最多选择一个商品！`)
        return false
      } else {
        ProductInfoData.value = JSON.parse(JSON.stringify(_ProductInfoData))
      }

      dialogExposed.close()
    },
    body: ({ data }: PageContext) => {
      return {
        type: 'crud',
        style: { paddingTop: 0 },

        actions: {
          query: {
            api: '/cabinet/admin/pms/AdminPmsProductQueryController/page',
            requestTransform: (req: any) => {
              console.log('1212', data)
              const queryForm = {
                ...req,
                ...data,
                current: 1,
                size: 500
              }
              return queryForm
            }
          }
        },
        searchOn: ['$page_product_search'],
        search: {
          items: [
            {
              type: 'input',
              prop: 'productName',
              label: '商品名称',
              placeholder: '请输入',
              span: 6
            },
            {
              type: 'input',
              prop: 'productCode',
              label: '商品编号',
              placeholder: '请输入',
              span: 6
            }
          ]
        },

        toolbar: { hidden: true },

        table: {
          showCheckbox: true,
          innerAttrs: {
            onSelectionChange: (selection: any) => {
              app.setPageData('checkedArr', selection)
            },
            noPager: true
          },
          // 没有添加过的商品才允许勾选
          checkboxSelectable: (row: any) => {
            const productCodes = ProductInfoData.value.map((item: any) => item.productCode)
            return !productCodes.includes(row.productCode)
          },
          columns: [
            { label: '商品编号', prop: 'productCode', minWidth: 180 },
            { label: '商品名称', prop: 'productName', minWidth: 150 },
            { label: '供应商', prop: 'supplierName', minWidth: 150 },
            { label: '规格', prop: 'productSpec', minWidth: 200 },
            {
              prop: 'mainImageUrl',
              label: '商品图片',
              component: {
                formItemType: 'label-image',
                label: '查看照片',
                uploadType: 'zscm-kdg-file'
              },
              minWidth: 120
            },
            { label: '成本价（元）', prop: 'costPrice', minWidth: 130 },
            { label: '销售价（元）', prop: 'salePrice', minWidth: 130 },
            { label: '划线价（元）', prop: 'linePrice', minWidth: 130 }
          ]
        }
      }
    }
  }
}

// 清空商品
const clearAttrs = computed(() => {
  return {
    label: '清空商品',
    buttonType: 'danger',
    disabled: !ProductInfoData.value?.length,
    trigger: async (allAttrs: any, ctx: any) => {
      const { MessageBox } = ctx.app.useMessage()
      await MessageBox.confirm('确定清空商品吗？', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })
      app.setPageData('checkedArr', [])
      ProductInfoData.value = []
    }
  }
})

await initData()
</script>

<style lang="scss" scoped>
.c-cabinet-shipment-info {
  display: inline-block;
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 15px;
  box-sizing: border-box;
  .c-cabinet-info-card {
    margin: 4px;
    --media-height: 150px;
    .c-info-card--header {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .icon {
        display: inline-block;
        margin-right: 10px;
        width: 4px;
        height: 20px;
        border-radius: 4px;
        background-color: #409eff;
      }
      .title {
        font-weight: bold;
        min-width: 66px;
      }
      .tip {
        color: red;
        word-break: break-all;
      }
    }
  }

  .all-product-info-wrap {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  .all-product-info-item {
    // float: right;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    font-size: 12px;

    .all-product-info-price {
      width: 180px;
      text-align: right;
    }
  }

  // .footer-wrap {
  //   display: flex;
  //   justify-content: flex-end;
  //   height: auto;
  // }
}
.dashed-line {
  width: 300px;
  border-bottom: 1px dashed #aaa;
  margin: 5px 0 8px 0;
  height: 1px;
}
.red {
  color: #ff0000;
}
.kdgzhsj {
  flex: 0 0 80px;
  width: 80px;
  height: 28px;
  background: url('/images/kdgzhsj.png') center center;
  background-size: 100% 100%;
  margin-left: 10px;
  cursor: pointer;
}
.youzan {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 110px;
  width: 110px;
  height: 28px;
  color: #ffffff;
  background: #d85222;
  border-radius: 28px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
